import { useTranslation } from 'react-i18next';
import { Typography, Container } from '@mui/material';

const NotAllowedPage = () => {
    const { t } = useTranslation();
    return (
        <Container sx={{ mt: 6 }}>
            <Typography variant="h1" align="center">
                {t('Not allowed')}
            </Typography>
            <Typography variant="body1" align="center">
                {t('You are not allowed to access this page.')}
            </Typography>
        </Container>
    );
};

export default NotAllowedPage;